import { useQuery } from "@tanstack/react-query";
import { fetchAdminThankYou } from "../api/admin";

export function useAdminThankYou(filters?: { search?: string; org?: string }) {
  return useQuery({
    queryKey: ["admin", "thankyou", filters],
    queryFn: () => fetchAdminThankYou(filters),
  });
}
